import { AnimatePresence, motion } from "motion/react";
import { FC } from "react";

import {
  IGridRowProps,
  TableWrapperGeneric,
  useTableDefsRides,
} from "@ryde/controls";
import { useRidesGridSplitter } from "@ryde/redux";
import {
  IColumnDef,
  IExtendableDto,
  IRideDto,
  RidesViewTypeEnum,
} from "@ryde/shared";

import { RidesRoutes } from "../../routes";
import { GridRowRendererRides, RideDetailsPanel } from "../grid";
import { RidesGridTableWrapperStyled } from "./rides-grid.styled";
import { RidesMapMultiSelect } from "./rides-map-multi-select";

export const RidesGridMultiSelect: FC = () => {
  const { tableDefsRides } = useTableDefsRides();

  const {
    mapOpen,
    x,
    onDragStartHandler,
    onDragEndHandler,
    gridSizeProps,
    mapSizeProps,
    dragConstraints,
  } = useRidesGridSplitter(RidesViewTypeEnum.GridMultiSelect);

  return (
    <>
      <RidesGridTableWrapperStyled>
        <motion.div className="grid_panel thin_scrollbar" style={gridSizeProps}>
          <TableWrapperGeneric
            RenderSubComponent={({ row }) => {
              return <RideDetailsPanel rideDto={row.original as IRideDto} />;
            }}
            GridRowRenderer={
              GridRowRendererRides as unknown as FC<
                IGridRowProps<IExtendableDto>
              >
            }
            tableDefs={tableDefsRides as IColumnDef<IExtendableDto, any>[]}
          />
        </motion.div>
        <AnimatePresence>
          {mapOpen && (
            <motion.div
              className="splitter"
              key="splitter"
              dragElastic={0}
              dragMomentum={false}
              onDragStart={onDragStartHandler}
              onDragEnd={onDragEndHandler}
              dragConstraints={dragConstraints}
              drag="x"
              style={{
                cursor: "col-resize",
                x,
              }}
            />
          )}

          {mapOpen && (
            <motion.div
              key="map_panel"
              className="map_panel"
              style={mapSizeProps}
            >
              <RidesMapMultiSelect />
            </motion.div>
          )}
        </AnimatePresence>
      </RidesGridTableWrapperStyled>
      <RidesRoutes />
    </>
  );
};
